import { render, staticRenderFns } from "./AddressLookup.vue?vue&type=template&id=5b23eee1&scoped=true"
import script from "./AddressLookup.vue?vue&type=script&lang=ts"
export * from "./AddressLookup.vue?vue&type=script&lang=ts"
import style0 from "./AddressLookup.vue?vue&type=style&index=0&id=5b23eee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b23eee1",
  null
  
)

export default component.exports